import PropTypes from 'prop-types';
import React from 'react'

import { TextLoader } from '~/components'

import MainFeed from './DashboardFeed-Main'
import UserFeed from './DashboardFeed-Users'

export default class extends React.Component {
    static propTypes = {
		camp: PropTypes.object.isRequired,
		campSlug: PropTypes.string,
		canAccess: PropTypes.func.isRequired,
		editingUsers: PropTypes.bool
	};

    render() {

		var campUsers = {};
		campUsers.pending 	= !!this.props.camp && ('requested_users' in this.props.camp) ? this.props.camp.requested_users : [];
		campUsers.current 	= !!this.props.camp && ('current_users' in this.props.camp) ? this.props.camp.current_users : [];
		campUsers.removed 	= !!this.props.camp && ('removed_users' in this.props.camp) ? this.props.camp.removed_users : [];
		if( !!this.props.camp && ('rejected_users' in this.props.camp) ) campUsers.removed = campUsers.removed.concat( this.props.camp.rejected_users );

		return (

			this.props.canAccess()
        		? this.props.editingUsers
	            	? <UserFeed users={campUsers} campID={this.props.camp.ID} />
	            	: <MainFeed camp={this.props.camp} campSlug={this.props.campSlug} />
            	: <p className="text-center mbot0 ptop20 pbot20">
            		{this.props.camp.status === 'requested' 
            			? "Awaiting approval"
            			: "You don't have access"
            		}
        		</p>
			
		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/DashboardFeed-Camps.jsx